import { RoomAvailabilityState } from './types';

export const state = (): RoomAvailabilityState => initialState();

export const initialState = (): RoomAvailabilityState => ({
  roomAvailabilities: {
    items: [],
    isLoading: false,
    total: 0,
    searchParams: {
      dataOption: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [false],
        groupBy: [],
        groupDesc: [],
        multiSort: true,
        mustSort: false,
      },
      filter: '',
      orClauseFieldsIds: ['Name'],
    },
  },
});
